export enum PaymentProvider {
  MercadoPago = 'mercadopago',
  Uala = 'uala',
  Payway = 'payway',
}

export enum PaymentScope {
  Total = 'total',
}

export interface PaymentConfigDTO {
  id: string;
  access_token: string;
  user_id: string;
  token_expires_at: Date;
  scope: PaymentScope;
  refresh_token: string;
  comission_rate: number;
  avantti_rate: number;
  accreditation_time: number;
  effective_comission_rate: number;
  uses_vat: boolean;
  provider: PaymentProvider;
  business_id: string;
  internal: boolean;
}
